<template>
  <div class="Banner">
    <div class="Banner_content">
      <div class="Banner_content_test">
        <p>SDGs新闻</p>
        <!-- <div class="test">
          欢迎来到⼤数据系统应⽤市场！ 在这⾥，您可以查看SDGs的可视化数据。
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.Banner {
  width: 100%;
  height: 300px;
  position: relative;
      object-fit: cover;
  background: url("../../../assets/image/News/News_bg.jpg") no-repeat ;
  background-size: 100% 100%;
  .Banner_content {
    width: 1200px;
    height: 300px;
    margin:  auto;

    .Banner_content_test {
      height: 300px;
      width: 100%;
          display: flex;
    flex-direction: column;
    justify-content: center;

      p {
        color: #fff;
        font-size: 36px;
        font-weight: 600;
      }
      .test{
        margin-top: 20px;
        color: #fff;
        font-size: 16px;
      }
    }
  }
}
</style>